<div
	class="c-portlet o-block u-width-100p _u-width-100p u-shadow-mini u-bg-primary c-portlet_box_specs"
	style="position: relative"
>
	<app-loader [showLoader]="showLoad"></app-loader>
	<div
		*ngIf="sectionclass != 'cox_ctv_featured_networks'"
		class="c-portlet__header o-stack o-stack--center o-stack--splitted u-border-bottom u-px-small u-py-mini c-portlet-gap u-border-bottom"
		style="position: relative"
	>
		<div class="o-stack__cell {{ sectionclass }}_header">
			<h5>{{ sectiontitle }}</h5>
			<a
				href="#"
				class="datatable_download_icon"
				*ngIf="downloadConfiguration && downloadConfiguration.enableDownload && hasData"
				(click)="downloadDataInCSV($event)"
				target="_blank"
			>
				<i class="fa fa-download" aria-hidden="true" *ngIf="sectionclass != 'r6-featured-networks'; else elseBlock"></i>
				<ng-template #elseBlock>
					<img class="downloadIcon" src="../../../../../assets/creative-assets/download.svg" />
				</ng-template>
			</a>
		</div>
	</div>
	<div
		*ngIf="sectionclass == 'cox_ctv_featured_networks'"
		class="c-portlet__header o-stack o-stack--center o-stack--splitted u-px-small u-py-mini c-portlet-gap"
		style="position: relative"
	>
		<div class="cox_ctv_featured_networks_header primary-color" *ngIf="sectionclass == 'cox_ctv_featured_networks'">
			{{ sectiontitle }} &nbsp;&nbsp;
			<a
				href="#"
				*ngIf="downloadConfiguration && downloadConfiguration.enableDownload && hasData"
				(click)="downloadDataInCSV($event)"
				target="_blank"
				><i class="fa fa-download" aria-hidden="true"></i
			></a>
		</div>
		<a
			href="#"
			class="datatable_download_icon"
			*ngIf="
				downloadConfiguration && downloadConfiguration.enableDownload && sectionclass !== 'cox_ctv_featured_networks'
			"
			(click)="downloadDataInCSV($event)"
			target="_blank"
		>
			<i class="fa fa-download" aria-hidden="true" *ngIf="!downloadConfiguration.downloadPNGIcon"></i>
			<img
				class="downloadIcon"
				src="../../../../../assets/images/Download_Icon.svg"
				*ngIf="downloadConfiguration.downloadPNGIcon"
			/>
		</a>
	</div>
	<div class="c-portlet__content r6-min-height">
		<div>
			<div class="list">
				<div
					[ngClass]="{
						donutTable: sectionclass != 'cox_ctv_featured_networks',
						donutTablecox: sectionclass == 'cox_ctv_featured_networks',
						singleNetwork: featuredNetworks.length == 1
					}"
				>
					<div class="table" *ngIf="sectionclass == 'cox_ctv_featured_networks' || sectionclass == ''">
						<div
							*ngFor="
								let featuredNetwork of featuredNetworks | paginate : { itemsPerPage: itemsPerPage, currentPage: p2 };
								index as i;
								let l = count
							"
							[ngClass]="{
								breakClass: i == breakNumber,
								marginClass: l <= breakNumber
							}"
							[class.r2featurednetwork]="true"
							[class]="sectionclass"
						>
							<app-ctv-network-donut
								[events]="sectionclass == 'cox_ctv_featured_networks'"
								[completionPercentage]="featuredNetwork.completionRate"
								[networkUrl]="featuredNetwork.logoPath"
							></app-ctv-network-donut>
							<div
								class="description"
								style="margin-top: -7%"
								*ngIf="sectionclass == 'cox_ctv_featured_networks'; else DescElseBlock"
							>
								<p class="completionRatelabel">
									{{ featuredNetwork.completionRate | number : '1.0-2' }}% Completion Rate
								</p>
								<p class="networkName" title="{{ featuredNetwork.networkName }}">{{ featuredNetwork.networkName }}</p>
							</div>
							<ng-template #DescElseBlock>
								<div class="description">
									<p style="font-weight: bold" title="{{ featuredNetwork.networkName }}">
										{{ featuredNetwork.networkName }}
									</p>
									<p>{{ featuredNetwork.completionRate | number : '1.0-2' }}% Completion Rate</p>
								</div>
							</ng-template>
						</div>
						<div style="clear: both"></div>
					</div>
					<div class="table r6-networks" *ngIf="sectionclass == 'r6-featured-networks'">
						<div
							*ngFor="
								let featuredNetwork of featuredNetworks | paginate : { itemsPerPage: itemsPerPage, currentPage: p2 };
								index as i
							"
							[ngClass]="{ breakClass: i == breakNumber, 'div-5': (i + 1) % 5 == 0 }"
							class="donut-div"
						>
							<div class="network-title">{{ featuredNetwork.networkName }}</div>
							<div class="featured-img">
								<img [src]="featuredNetwork.logoPath" />
							</div>
							<div class="network-value">{{ featuredNetwork.completionRate | number : '1.0-2' }}%</div>
						</div>
						<div style="clear: both"></div>
					</div>
				</div>
				<pagination-template
					#p="paginationApi"
					(pageChange)="p2 = $event"
					[ngClass]="{
						pagination: sectionclass != 'cox_ctv_featured_networks' && sectionclass != 'r6-featured-networks',
						cox_pagination: sectionclass == 'cox_ctv_featured_networks',
						r6_featured_network_pagination: sectionclass === 'r6-featured-networks'
					}"
					*ngIf="featuredNetworks.length > itemsPerPage"
				>
					<ul class="pager">
						<li
							[class.disabled]="p.isFirstPage()"
							style="float: left"
							[ngClass]="{ firstArrow: sectionclass == 'cox_ctv_featured_networks' }"
						>
							<a (click)="p.setCurrent(1)">
								<i class="fa fa-step-backward icons"></i>
							</a>
						</li>
						<li [class.disabled]="p.isFirstPage()" style="float: left">
							<a (click)="p.previous()">
								<i *ngIf="sectionclass != 'cox_ctv_featured_networks'" class="fa fa-angle-left icons"></i>
								<img
									class="arrow_image"
									*ngIf="sectionclass == 'cox_ctv_featured_networks'"
									src="../../../../../assets/partner-assets/default-r5/icons/left_arrow.png"
								/>
							</a>
						</li>
						<li
							role="button"
							*ngFor="let page of p.pages"
							[class.current]="p.getCurrent() === page.value"
							class="pages"
							style="float: left"
						>
							<a
								(click)="p.setCurrent(page.value)"
								*ngIf="p.getCurrent() !== page.value"
								[class.primary-color-bg-on-hover]="p.getCurrent() !== page.value"
							>
								{{ page.label }}
							</a>
							<a *ngIf="p.getCurrent() === page.value" [class.primary-color-bg]="p.getCurrent() === page.value">
								{{ page.label }}
							</a>
						</li>
						<li [class.disabled]="p.isLastPage()" style="float: left">
							<a (click)="p.next()">
								<i *ngIf="sectionclass != 'cox_ctv_featured_networks'" class="fa fa-angle-right icons"></i>
								<img
									class="arrow_image"
									*ngIf="sectionclass == 'cox_ctv_featured_networks'"
									src="../../../../../assets/partner-assets/default-r5/icons/right_arrow.png"
								/>
							</a>
						</li>
						<li
							[class.disabled]="p.isLastPage()"
							style="float: left"
							[ngClass]="{ lastArrow: sectionclass == 'cox_ctv_featured_networks' }"
						>
							<a (click)="p.setCurrent(p.getLastPage())">
								<i class="fa fa-step-forward icons"></i>
							</a>
						</li>
					</ul>
				</pagination-template>
			</div>
		</div>
		<div class="no-data-container r11-no-data" *ngIf="!hasData">
			<div
				class="c-portlet__header o-stack o-stack--center o-stack--splitted u-border-bottom u-px-small u-py-mini c-portlet-gap u-border-bottom pos-relative r11-featured-networks"
			>
				<div
					class="o-stack__cell no_data_header"
					[ngClass]="{ 'cox_ctv_featured_networks_header primary-color': sectionclass == 'cox_ctv_featured_networks' }"
				>
					<h5 *ngIf="sectionclass !== 'cox_ctv_featured_networks'">{{ sectiontitle }}</h5>
					<span *ngIf="sectionclass == 'cox_ctv_featured_networks'">{{ sectiontitle }}</span>
				</div>
			</div>
			<div class="no-data-feature-network">
				<div class="map-no-data no-data-text">{{ nodatamessage }}</div>
			</div>
		</div>
	</div>
	<div class="clear"></div>
</div>
